import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import usedIn from "./usedIn";
import UsedInLink from "./UsedInLink";

export default function UsedInBadge({ arg, alt }) {
  const usedInData = usedIn(arg);

  return usedInData.length > 0 ? (
    <OverlayTrigger
      trigger="click"
      placement="right"
      rootClose
      overlay={
        <Popover>
          <div
            className="p-3 overflow-auto"
            style={{ maxHeight: "75vh", minWidth: "200px" }}
          >
            <UsedInLink arg={arg} />
          </div>
        </Popover>
      }
    >
      <span
        // title={`Used in: ${usedInData.map(
        //   (el) =>
        //     (el.workflow &&
        //       `\n${el.workflow.Label}${
        //         el.eventHandler ? `: ${el.eventHandler.Label}` : ""
        //       }`) ||
        //     (el.messageTemplate && `\n${el.messageTemplate?.Label}`) ||
        //     (el.contactSet && `\n${el.contactSet?.Label}`)
        // )}`}
        className={`btn badge rounded-pill ${
          arg.IsParameter ? "bg-colored" : "bg-secondary"
        }`}
      >
        {usedInData.length}
      </span>
    </OverlayTrigger>
  ) : (
    alt
  );
}
